import { IntlProvider } from "react-intl";

import enMessages from "./messages/en.json";
import trMessages from "./messages/tr.json";

import { AppContext } from "@context/AppContext";
import { useContext } from "react";

const HARDCODED_MESSAGES = {
  en: enMessages,
  tr: trMessages,
};

export default function I18nProvider({ children }) {
  /** */

  const { locale = "en" } = useContext(AppContext);

  return (
    <IntlProvider locale={locale} messages={HARDCODED_MESSAGES[locale]} onError={() => {}}>
      {children}
    </IntlProvider>
  );
}
